import { render } from "./Contact.vue?vue&type=template&id=4d48ab53&scoped=true"
import script from "./Contact.vue?vue&type=script&lang=js"
export * from "./Contact.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-4d48ab53"

export default script